<div class="h-100 mx-2 d-flex" (click)="openDialog()" [matTooltip]="tooltipText">
    <mat-progress-bar mode="determinate" bufferValue="100" class="m-auto" [value]="percent"></mat-progress-bar>
</div>